var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawSelectingTeam8Uux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 898.235,
    height: 629.902,
    viewBox: "0 0 898.235 629.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-191 -152.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M727.966,744.257s7.3-24.57-20.468-38.559Z",
    transform: "translate(62.789 15.395)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M730.561,745.406s2.895-24.249,35.237-25.769Z",
    transform: "translate(61.105 14.377)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M982.957,747.585c-5.136,21.131-274.791,19.357-274.383,0C713.71,726.454,983.365,728.228,982.957,747.585Z",
    transform: "translate(60.856 19.206)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 4.354,
    cy: 4.354,
    rx: 4.354,
    ry: 4.354,
    transform: "translate(279.754 203.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 4.354,
    cy: 4.354,
    rx: 4.354,
    ry: 4.354,
    transform: "translate(296.279 203.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 4.354,
    cy: 4.354,
    rx: 4.354,
    ry: 4.354,
    transform: "translate(312.804 203.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 552.899,
    height: 3.073,
    transform: "translate(273.529 218.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M894.817,636.335s-3.2-10.845,2.014-7.307,20.391,8.851,14.923,17.36-38.195,55.542-43.487,46.222c-2.938-5.174,7.3-49.061,7.3-49.061s7.283-1.683,8.326,0S894.817,636.335,894.817,636.335Z",
    transform: "translate(91.455 22.899)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M689.792,207.972l-.978,17.6L676.1,251l42.054-1.956-2.934-26.406,1.956-10.758Z",
    transform: "translate(249.526 174.476)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M839.559,371s6.846,7.824,24.45-.978l13.692,66.5,1.956,59.658-58.68-1.956.978-60.636Z",
    transform: "translate(94.87 41.762)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M805.636,507.2s6.318,31.039,18.13,23.519-2.546-29.311-2.546-29.311Z",
    transform: "translate(95.99 32.168)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M712.95,557.116l-.978,16.626,15.648,4.89V556.138Z",
    transform: "translate(246.906 149.05)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M657.11,369.394v97.8l55.746,47.923,13.691-23.473-39.12-32.273,9.78-24.45,41.076-26.407V370.372Z",
    transform: "translate(250.913 162.688)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M856.848,561.511l5.868,49.878,1.956,66.5H890.1s8.8-58.68-.978-73.35L896.946,540l-7.824-25.428Z",
    transform: "translate(92.25 31.206)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M879.188,704.168s.978-3.912-5.868-3.912-9.78.978-9.78,1.956a42.365,42.365,0,0,1-.978,4.89s-17.6,44.01,0,42.054S883.1,738.4,883.1,738.4l1.956-28.362s-1.956-2.395-2.934-2.175S879.188,704.168,879.188,704.168Z",
    transform: "translate(92.405 17.646)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 21.516,
    cy: 21.516,
    r: 21.516,
    transform: "translate(933.451 349.196)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M865.924,375.49l-6.846-7.824L872.314,351.1l5.346,5.8,31.3,13.692-8.8,86.064s-.978,25.428,4.89,43.032c0,0-12.714,15.648-32.274,11.736l-25.428,4.89S844.408,390.16,865.924,375.49Z",
    transform: "translate(92.955 43.144)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M686.373,240.449l1.124-16.3-5.035,6.519-26.406,19.56,2.934,108.558,8.8,4.891L682.461,247.3Z",
    transform: "translate(250.99 173.295)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M817.71,381.631l-6.846.978s-4.89,8.8-4.89,9.78-1.956,51.834-1.956,51.834-3.423,51.345,2.445,61.125l17.314-18.628-6.067-17.069Z",
    transform: "translate(96.181 40.915)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M706.983,483.892l1.349,32.736-4.067-3.5Z",
    transform: "translate(247.469 154.326)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M742.039,497.981l-1.427.707-1.53,43.855,3.535-4.55Z",
    transform: "translate(244.927 153.297)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M928.525,512.457s-4.89,31.3,8.8,28.362,7.824-28.362,7.824-28.362Z",
    transform: "translate(87.078 31.361)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M904.017,372.136h8.8s5.868,2.934,6.846,11.736,14.67,47.922,14.67,47.922,15.648,64.548,14.67,73.35h-24.45l1.956-17.6-26.406-70.416Z",
    transform: "translate(89.091 41.608)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M842.977,302.268l-4.1-1.642s8.576-9.442,20.508-8.621l-3.356-3.695s8.2-3.284,15.661,5.337c3.92,4.532,8.456,9.859,11.284,15.859h4.393l-1.833,4.037,6.417,4.037-6.586-.725a22.557,22.557,0,0,1,.179,6.7,8.664,8.664,0,0,1-3.172,5.667h0s-5.087-10.529-5.087-12.171v4.105s-4.1-3.695-4.1-6.158l-2.237,2.874-1.119-4.516-13.8,4.516,2.237-3.695-8.576,1.232,3.356-4.516s-9.695,5.337-10.068,9.852a21.681,21.681,0,0,1-3.211,8.795S832.163,308.426,842.977,302.268Z",
    transform: "translate(93.688 47.775)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 635.631,
    height: 407.086,
    transform: "translate(191.271 152.439)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 635.631,
    height: 27.004,
    transform: "translate(191 152.079)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 599.28,
    height: 155.185,
    transform: "translate(209.972 200.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 599.28,
    height: 155.185,
    transform: "translate(210.351 381.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(412.34 235.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 324.331,
    height: 14.455,
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 115.639,
    height: 14.455,
    transform: "translate(0 36.137)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 230.375,
    height: 14.455,
    transform: "translate(0 72.274)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(282.246 224.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M355.985,256.388a53.871,53.871,0,0,1-8.807,29.607,52.67,52.67,0,0,1-3.962,5.321,54.386,54.386,0,0,1-11.609,10.315q-1.771,1.174-3.642,2.2a53.7,53.7,0,0,1-21.042,6.48c-1.679.164-3.386.242-5.108.242a53.954,53.954,0,0,1-13.978-1.828,51.9,51.9,0,0,1-7.562-2.625q-1.878-.811-3.671-1.764a53.355,53.355,0,0,1-8.159-5.285q-1.782-1.387-3.436-2.924a54.167,54.167,0,1,1,90.975-39.736Z",
    transform: "translate(-247.649 -202.213)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M304.673,283.222s4.931,13.7,1.1,21.368,6.027,16.437,6.027,16.437,25.752-13.15,22.464-19.725-8.766-15.341-7.671-20.82Z",
    transform: "translate(-263.634 -224.154)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 17.533,
    cy: 17.533,
    rx: 17.533,
    ry: 17.533,
    transform: "translate(33.095 29.207)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M300.545,337.355a51.9,51.9,0,0,1-7.562-2.625l.47-13.31,4.93-10.962a22.923,22.923,0,0,0,3.543,2.283c.3.164.6.32.932.477,4.624,2.234,12.178,4.2,19.5-1.28a27.88,27.88,0,0,0,6.737-7.583l13.672,7.747.718,8.394.832,9.767q-1.771,1.174-3.642,2.2a53.7,53.7,0,0,1-21.042,6.48c-1.679.164-3.386.242-5.108.242A53.95,53.95,0,0,1,300.545,337.355Z",
    transform: "translate(-260.357 -230.846)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M298.543,301.44v.021l-.69,7.156-.363,3.784-.533,5.627-1.778,18.51a51.9,51.9,0,0,1-7.562-2.625q-1.878-.811-3.671-1.764a53.356,53.356,0,0,1-8.159-5.285l-1.949-9,.149-.1Z",
    transform: "translate(-254.99 -230.029)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M351.052,329.865a53.7,53.7,0,0,1-21.042,6.48c.4-6.658.982-13.089,1.643-18.815.341-2.938.7-5.684,1.081-8.188,1.188-8.045,2.468-13.509,3.386-14.248l6.061,4,24.656,8.764-.534,9.49a54.387,54.387,0,0,1-11.609,10.315Q352.923,328.841,351.052,329.865Z",
    transform: "translate(-270.737 -228.25)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M275.207,333.048q-1.782-1.387-3.436-2.924l.939-6.075.7-.1,3.137-.448,6.822,14.832a53.351,53.351,0,0,1-8.159-5.285Z",
    transform: "translate(-254.411 -236.213)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M378.21,316.578a52.666,52.666,0,0,1-3.962,5.321,54.386,54.386,0,0,1-11.609,10.315q-1.771,1.174-3.642,2.2l-.647-2.824,3.457-9.141,4.211-11.133,8.764,1.1A51.321,51.321,0,0,1,378.21,316.578Z",
    transform: "translate(-278.68 -232.797)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M326.949,241.387A20.483,20.483,0,0,0,315.3,232.48l-3.562,2.85,1.385-3.324a18.855,18.855,0,0,0-3.521-.2l-3.205,4.121,1.327-3.98a20.287,20.287,0,0,0-13.995,8.325c-4.079,5.882-4.768,14.062-.755,19.99,1.1-3.385,2.438-6.561,3.54-9.946a10.017,10.017,0,0,0,2.61.013l1.34-3.127.374,2.994c4.153-.362,10.314-1.156,14.251-1.884l-.383-2.3,2.291,1.909c1.206-.278,1.923-.53,1.863-.722,2.928,4.721,5.83,7.736,8.758,12.457C328.727,253,330.689,247.462,326.949,241.387Z",
    transform: "translate(-259.602 -210.504)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 1.187,
    cy: 2.374,
    rx: 1.187,
    ry: 2.374,
    transform: "translate(65.189 43.816)",
    fill: "#ffb8b8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M356.06,429.339a53.91,53.91,0,0,1-8.813,29.627,52.691,52.691,0,0,1-3.965,5.325,54.426,54.426,0,0,1-11.617,10.322q-1.773,1.175-3.645,2.2a53.739,53.739,0,0,1-21.057,6.485c-1.68.164-3.388.242-5.111.242a53.986,53.986,0,0,1-13.988-1.829,51.937,51.937,0,0,1-7.567-2.627q-1.879-.812-3.673-1.765a53.393,53.393,0,0,1-8.165-5.289q-1.783-1.388-3.438-2.926a54.2,54.2,0,1,1,91.039-39.764Z",
    transform: "translate(31.887 29.009)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(308.446 433.045)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 6.645,
    height: 50.592,
    transform: "translate(21.974 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 6.645,
    height: 50.592,
    transform: "translate(50.592 21.974) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(404.209 415.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250-2",
    "data-name": "Rectangle 250",
    width: 324.331,
    height: 14.455,
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251-2",
    "data-name": "Rectangle 251",
    width: 115.639,
    height: 14.455,
    transform: "translate(0 36.137)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252-2",
    "data-name": "Rectangle 252",
    width: 230.375,
    height: 14.455,
    transform: "translate(0 72.274)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(977.818 567.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M1004.717,580.212A55.661,55.661,0,0,1,982.7,624.575q-1.488,1.132-3.049,2.169-.4.266-.8.511c-.97.622-1.954,1.2-2.953,1.747q-.6.333-1.2.644c-.081.044-.156.081-.237.118-.511.266-1.021.526-1.539.77a54.529,54.529,0,0,1-6.994,2.768,55.266,55.266,0,0,1-11.664,2.368q-2.6.244-5.255.244a55.462,55.462,0,0,1-14.373-1.88,53.518,53.518,0,0,1-7.061-2.391c-.237-.1-.481-.2-.718-.3q-1.687-.733-3.308-1.576l-.466-.244q-1.765-.921-3.449-1.969a55.823,55.823,0,0,1-4.944-3.464q-1.21-.933-2.354-1.954c-.4-.34-.792-.7-1.177-1.051a56.82,56.82,0,0,1-4.256-4.4c-.533-.614-1.051-1.236-1.554-1.873a55.709,55.709,0,1,1,99.369-34.6Z",
    transform: "translate(-893.3 -524.499)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 8.349,
    cy: 8.349,
    r: 8.349,
    transform: "translate(64.745 63.973)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M992.913,610.808a8.35,8.35,0,0,1,7.35,12.312,8.347,8.347,0,1,0-13.868-9.172,8.329,8.329,0,0,1,6.519-3.14Z",
    transform: "translate(-917.493 -546.605)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 24.526,
    cy: 24.526,
    r: 24.526,
    transform: "translate(32.966 23.252)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M942.359,565.215a24.522,24.522,0,0,1,33.99-2.572c-.2-.191-.4-.383-.607-.568a24.526,24.526,0,1,0-32.59,36.66c.208.185.422.36.635.537a24.522,24.522,0,0,1-1.427-34.057Z",
    transform: "translate(-904.116 -532.654)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 15.796,
    cy: 15.796,
    r: 15.796,
    transform: "translate(41.488 40.504)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M954.977,607.308s2.078,19.122-1.247,21.2,19.122,4.988,19.122,4.988-3.326-20.785,4.988-26.189Z",
    transform: "translate(-908.917 -546.019)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M983.626,647.673v6.039c-.97.622-1.954,1.2-2.953,1.747q-.6.333-1.2.644v.118h-.237c-.511.266-1.021.525-1.54.77a54.506,54.506,0,0,1-6.994,2.768,55.274,55.274,0,0,1-11.664,2.368q-2.6.244-5.255.244a55.459,55.459,0,0,1-14.373-1.88,53.5,53.5,0,0,1-7.061-2.391c-.237-.1-.481-.2-.718-.3q-1.687-.733-3.308-1.576l-.466-.244q-1.765-.921-3.449-1.969a55.822,55.822,0,0,1-4.944-3.464q-1.21-.933-2.354-1.954c-.4-.341-.792-.7-1.177-1.051a56.809,56.809,0,0,1-4.256-4.4,20.484,20.484,0,0,1,.873-3.693l.008-.007a7.732,7.732,0,0,1,.4-.918c1.791-3.353,5.025-4.182,9.052-4.359,2.265-.1,4.774.007,7.431-.022,1.4-.007,2.842-.059,4.3-.192,9.148-.829,7.483-6.232,7.9-9.141.407-2.82,2.946-.377,3.116-.215l.007.007a32.279,32.279,0,0,0,16.6,2.916h.007a28.556,28.556,0,0,1,2.938-.222c2.576-.03,2.013.71,1.132,1.317a11.66,11.66,0,0,1-1.354.762s-.414,2.494-.829,6.239c-.4,3.582,6.461,5.262,7.031,5.388a.074.074,0,0,0,.037.015,13.816,13.816,0,0,1,7.616.192,9.032,9.032,0,0,1,5.684,6.461Z",
    transform: "translate(-898.076 -550.217)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M935.963,659.37c-.022.674-.059,1.3-.1,1.88-.237-.1-.481-.2-.718-.3q-1.687-.733-3.308-1.576l-.466-.244q-1.765-.921-3.449-1.969a17.334,17.334,0,0,1,.192-1.761,32.226,32.226,0,0,0-2.59-18.081c-.2-.407-.318-.629-.318-.629s2.909-2.494,7.061,0a2.746,2.746,0,0,1,.688.607C935.711,640.556,936.251,652.31,935.963,659.37Z",
    transform: "translate(-901.592 -553.366)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M998.222,661.95c-.007.252-.022.511-.037.77a54.51,54.51,0,0,1-6.994,2.768l-.141-3.538-.533-14.047a2.229,2.229,0,0,1,.259-1.169A2.269,2.269,0,0,1,992.8,645.5h5.077c.252,0,.429.511.548,1.436C998.748,649.509,998.592,655.26,998.222,661.95Z",
    transform: "translate(-918.564 -555.946)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M797.018,443.487v15.8h3.658l4.655-4.988-.623,4.988h16.17l-1-4.988,2,4.988h2.578v-15.8Z",
    transform: "translate(-753.244 -406.932)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 1.247,
    cy: 2.286,
    rx: 1.247,
    ry: 2.286,
    transform: "translate(40.033 50.689)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 1.247,
    cy: 2.286,
    rx: 1.247,
    ry: 2.286,
    transform: "translate(72.042 50.689)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M1011.279,658.365q-1.488,1.133-3.049,2.169-.4.267-.8.511c-.97.622-1.954,1.2-2.953,1.747q-.6.333-1.2.644v-11.76s1.606,1.28,4.152,3.412C1008.548,656.027,1009.851,657.137,1011.279,658.365Z",
    transform: "translate(-921.881 -557.549)",
    fill: "#f6841f"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 4.467,
    cy: 4.467,
    r: 4.467,
    transform: "translate(228.572 161.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 4.467,
    cy: 4.467,
    r: 4.467,
    transform: "translate(245.528 161.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 4.467,
    cy: 4.467,
    r: 4.467,
    transform: "translate(211.572 161.045)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSelectingTeam8Uux);
export default __webpack_public_path__ + "static/media/undraw_selecting_team_8uux.bccc7746f8ca1d97935101de08d276bc.svg";
export { ForwardRef as ReactComponent };